import logo from './logo.svg';
import './App.css';
import Nostra from './Nostra.js'
function App() {
  return (
    <Nostra></Nostra>
  );
}

export default App;
